import React, { useEffect, useState } from "react";
import "../../assets/styles/local/DashBoard.css";
import { useSelector, useDispatch } from "react-redux";
import { ActiveWorker } from "../../redux/actions/action";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const WorkerCard = () => {
  const dispatch = useDispatch();
  const companyid = window.localStorage.getItem("companyid");
  const workersActivity = useSelector(
    (state) => state.user.showWorkersActivity
  );
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("BI-Dashboard-List").then(data => setFetchTranslationList(data));
  }, []);

  useEffect(() => {
    dispatch(ActiveWorker(companyid));
  }, [dispatch, companyid]);

  return (
    <>
      <div className="workerCard workerCard_Res">
        <table>
          <tr className="topRow">
            <th className="worker">
              {/* Workers */}
              {t("Workers")}
            </th>
            <th className="workTitle">
              {/* ACTIVE */}
              {t("ACTIVE")}
            </th>
            <th className="workTitle">
              {/* HOURS WORKED */}
              {t("HOURS WORKED")}
            </th>
            <th className="workTitle">
              {/* HOURS COST */}
              {t("HOURS COST")}
            </th>
          </tr>

          {workersActivity?.map((worker, index) => (
            <tr key={index} className={index % 2 === 0 ? "oddRow" : ""}>
              <th>{worker.worker}</th>
              <td>{worker.active}</td>
              <td>{`${worker.hoursworked ? (Number(worker.hoursworked).toFixed(2)) : 0}h`}</td>
              <td>{`€ ${worker.hourscost ? (Number(worker.hourscost).toFixed(2)) : 0}`}</td>
            </tr>
          ))}
        </table>
      </div>
    </>
  );
};

export default WorkerCard;
